import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-blend-type-full",
  "use": "icon-blend-type-full-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-blend-type-full\"><path d=\"M10 3c-.3 0-.7 0-1 .1-.4.1-.7.3-1 .7-.3-.4-.6-.6-1-.7C6.7 3 6.3 3 6 3 3.2 3 1 5.2 1 8s2.2 5 5 5c.3 0 .7 0 1-.1.4-.1.7-.3 1-.6.3.3.6.5 1 .6.3.1.7.1 1 .1 2.8 0 5-2.2 5-5s-2.2-5-5-5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol